import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

class PrivacyPolicy extends Component {
  render() {
    const { config } = this.props;
    return (
      <div
        className="container mar-t-100 static-content-container mar-b-20"
        style={{
          flex: "1",
          flexBasis: "100%",
        }}
      >
        <Helmet>
          <title>Privacy Policy | {config.brand}</title>
        </Helmet>
        <div className="col-md-8 col-md-offset-2">
          <h3> Privacy Policy </h3>
          <p style={{ fontSize: "14px" }}>
            This privacy policy has been compiled to better serve those who are
            concerned with how their 'Personally identifiable information' (PII)
            is being used online. PII, as used in US privacy law and information
            security, is information that can be used on its own or with other
            information to identify, contact, or locate a single person, or to
            identify an individual in context.
          </p>
          <p style={{ fontSize: "14px" }}>
            Please read our privacy policy carefully to get a clear
            understanding of how we collect, use, protect or otherwise handle
            your Personally Identifiable Information in accordance with our
            systems. By using our sites, app or other systems, you are agreeing
            to this Privacy Policy.
          </p>
          <h4>Data Collection</h4>
          <div style={{ fontSize: "14px" }}>
            <p>
              We collect information from you when you register on our site,
              place an order, subscribe to a newsletter, respond to a survey,
              fill out a form, enter information on our site or otherwise
              interact with our services. The information we collect is used to
              process orders, detect and prevent fraud, track trends and better
              understand how users interact with our services.
            </p>
            <p>
              Information automatically collected when you browse or use our
              Site includes but is not limited to: device type, browser,
              operating system, IP address, Device geolocation, device ID,
              internet service provider, the search engine used, referring
              sites, social media accounts that may be linked to you, and the
              websites you have accessed before, during and immediately after
              visiting or using our services.
            </p>
            <p>
              We can also ask you to provide additional information including:
            </p>
            <ul>
              <li>
                Contact information, such as name, email address, mailing
                billing and shipping addresses, fax or phone number
              </li>
              <li>
                Payment and financial information, such as credit or other
                payment card information, and bank account information.
              </li>
              <li>Social Security Number, tax ID or EIN number</li>
              <li>
                Unique identifiers such as user name, account number, or
                password; and,
              </li>
              <li>
                Preference information such as product wish lists, order
                history, or marketing preferences.
              </li>
              <li>
                Information about your business such as company name, company
                size, or business type.
              </li>
              <li>
                Demographic information, such as age, gender, interests and ZIP
                code;
              </li>
            </ul>
            <p>
              We may also combine the information you provide with information
              from third-party sources. For example, we may confirm your address
              with the postal service or verify your personal information with a
              credit-reporting agency or other fraud prevention methods or
              services. We will treat the combined information in accordance
              with the terms of this Policy.
            </p>
            <p>
              We use "cookies" that collect non personal information for
              internal uses as described above. You have the option to delete
              and decline in your cookie setting, but please note that this may
              prevent you from using some features of our service.
            </p>
          </div>
          <div className="mar-t-50">
            <h4>Protecting your information</h4>
            <div style={{ fontSize: "14px" }}>
              <p>
                Our website, servers and systems are scanned on a regular basis
                for security holes and known vulnerabilities in order to make
                your visit to our site as safe as possible.
              </p>
              <p>
                Your personal information is contained behind secured networks.
                We use encryption and other accepted industry standards to
                secure the transmission of data. All credit card transactions
                are processed through a gateway provider and are not stored or
                processed on our servers.
              </p>
            </div>
          </div>
          <div className="mar-t-50">
            <h4>Third-party disclosure</h4>
            <div style={{ fontSize: "14px" }}>
              <p>
                We will not share Personal Information with third parties
                without your permission, except for the Permitted Purposes, as
                defined below. We may, however, use any information we have
                gathered from or about you, including but not limited to
                Personal Information, for our own internal business purposes,
                such as determining ways and methods of improving our services
                and Products.
              </p>
              <p>"Permitted Purposes" shall mean any of the following:</p>
              <ul>
                <li>
                  Complying with applicable laws and law enforcement requests,
                  with regulatory authorities, courts, and governmental agencies
                  to comply with legal orders, legal or regulatory requirements,
                  and government requests;
                </li>
                <li>
                  In order to take action regarding illegal activities or
                  suspected fraud or other abuses of our services.
                </li>
                <li>Investigating any disputed charges.</li>
                <li>
                  Fulfilling your product or service request and providing you
                  with a business or technical support function.
                </li>
                <li>Various methods of fraud detection and prevention.</li>
                <li>
                  Hosting, developing, and maintaining our service, our
                  database, and enhancing our network information.
                </li>
                <li>
                  Creating and publishing reports on trend and patterns for
                  business-related practices.
                </li>
                <li>
                  Satisfying requirements for promotions and sweepstakes in
                  which you have participated.
                </li>
                <li>
                  The transfer of our assets in the event of sale, merger,
                  acquisition by another company, or the sale of all or a
                  portion of our assets. We may disclose or sell such
                  information as an asset of the company in conjunction with the
                  sale to a third party of our company or portion of our assets.
                </li>
              </ul>
              <p>
                We do not sell, trade, or otherwise transfer to outside parties
                your personally identifiable information unless we provide users
                with advance notice. This does not include website hosting
                partners and other parties who assist us in operating our
                website, conducting our business, or serving our users, so long
                as those parties agree to keep this information confidential. We
                may also release information when it's release is appropriate to
                comply with the law, enforce our site policies, or protect ours
                or others' rights, property or safety.
              </p>
              <p>
                However, non-personally identifiable visitor information may be
                provided to other parties for marketing, advertising, or other
                uses.
              </p>
            </div>
          </div>
          <div className="mar-t-50">
            <h4>Third-party links</h4>
            <div style={{ fontSize: "14px" }}>
              <p>
                We do not include or offer third-party products or services on
                our website. However we may provide links that can take you to
                other websites that may be useful for you.
              </p>
            </div>
          </div>
          <div className="mar-t-50">
            <h4>Google</h4>
            <div style={{ fontSize: "14px" }}>
              <p>
                We use Google Analytics on our website. Google uses DART cookies
                to enable it to serve ads to our users based on previous visits
                to our site and other sites on the Internet as well as provides
                us with demographics and interests reporting. You can set
                preferences for how Google advertises to you using the Google Ad
                Settings page. Alternatively, you can opt out by visiting the
                Network Advertising initiative opt out page or permanently using
                the Google Analytics Opt Out Browser add on.
              </p>
            </div>
          </div>
          <div className="mar-t-50">
            <h4>Protecting Children's Online Privacy</h4>
            <div style={{ fontSize: "14px" }}>
              <p>
                We do not specifically market to children under 13. And request
                that such minors do not share personal information on our site.
              </p>
            </div>
          </div>
          <div className="mar-t-50">
            <h4>Policy Changes</h4>
            <div style={{ fontSize: "14px" }}>
              <p>
                We will from time to time update, modify or amend our Privacy
                Policy with information that is necessary. It is your sole
                responsibility to fully read and understand our policy and all
                updates, modifications, and amendments. If we make any changes
                to our Privacy Policy, we will notify you either by amending
                this Agreement.
              </p>
            </div>
          </div>
          <h4>Third-party links</h4>
          <p style={{ fontSize: "14px" }}>
            We do not include or offer third-party products or services on our
            website. However we may provide links that can take you to other
            websites that may be useful for you.
          </p>
          <h4>Google</h4>
          <p style={{ fontSize: "14px" }}>
            We use Google Analytics on our website. Google uses DART cookies to
            enable it to serve ads to our users based on previous visits to our
            site and other sites on the Internet as well as provides us with
            demographics and interests reporting. You can set preferences for
            how Google advertises to you using the Google Ad Settings page.
            Alternatively, you can opt out by visiting the Network Advertising
            initiative opt out page or permanently using the Google Analytics
            Opt Out Browser add on.
          </p>
          <h4>Protecting Children's Online Privacy</h4>
          <p style={{ fontSize: "14px" }}>
            We do not specifically market to children under 13. And request that
            such minors do not share personal information on our site.
          </p>
          <h4>Policy Changes</h4>
          <p style={{ fontSize: "14px" }}>
            We will from time to time update, modify or amend our Privacy Policy
            with information that is necessary. It is your sole responsibility
            to fully read and understand our policy and all updates,
            modifications, and amendments. If we make any changes to our Privacy
            Policy, we will notify you either by amending this Agreement.
          </p>
          <h4>Contacting Us</h4>
          <p style={{ fontSize: "14px" }}>
            If there are any questions regarding this privacy policy you may
            contact us:
          </p>
          <p style={{ fontSize: "14px" }}>
            {config.brand}.com
            <br />
            990 Cedarbridge Avenue
            <br />
            Brick, New Jersey 08723
            <br />
            United States
            <br />
            {config.supportEmail}
          </p>
          Last Edited on 2016-06-23
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    config: state.config,
  }),
  null
)(PrivacyPolicy);
